// ** React Imports
import { useEffect, useRef, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
    LeadCompanyStore,
    CompanyDialogStore,
    LeadSprintStore,
    SprintDialogStore,
    LeadActivityHistoryStore,
    ActivityHistoryDialogStore,
    LeadActivityCadenceStore,
    CadenceListDialogStore,
    LeadActivityOutcomeStore,
    ActivityOutcomes,
    ActivityNotesDialogStore,
    LeadOverrideStore,
    LeadListStore,
    ChangeCadenceStore,
    ChangeSprintStore,
    ChangeOwnerStore,
    ChangeDateStore,
} from 'src/stores/LeadStore';
import { getActivityEndpoint, getLeadEndpoint, leadEndpoints, optionsEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LeadDataFormater from './LeadDataFormater';
import LeadCompanyComponent from './LeadCompanyComponent';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { SelectOption } from 'src/types/common';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import Divider from '@mui/material/Divider';
import CustomDatePickerNoError from '../../common/CustomDatePickerNoError';
import DateTimeDisplayWithLabel from '../../common/DateTimeDisplayWithLabel';
import { formatDateLocal } from '../../../utils/date-utils';

const ChangeActivityDate = () => {
    const item = LeadScreenStore.useState((s) => s.selectedLead);

    const result = ChangeDateStore.useState((s) => s);

    const [options, setOptions] = useState([] as SelectOption[]);
    const [selectedValue, setSelectedValue] = useState<string>('');
    const [saveDisabled, setSaveDisabled] = useState<boolean>(true);

    const handleDateChange = (value: string) => {
        setSelectedValue(value as string);
        setSaveDisabled(false);
        ChangeDateStore.update((s) => {
            if (!item) return;
            s.leadId = item.id;
        });
        ChangeDateStore.update((s) => {
            s.activityDate = value as string;
        });
    };

    const onSubmit = async () => {
        let hasError = false;
        if (_.isEmpty(selectedValue)) {
            hasError = true;
        }

        if (hasError) return;

        await client
            .post(leadEndpoints.updatechangeactivitydate, result)
            .then(async (response) => {
                const updatedLeadResposne = await client.get(getLeadEndpoint.replace('{id}', result.leadId));

                LeadListStore.update((s) => {
                    const list = _.cloneDeep(s.list);
                    const leadIndex = list.items.findIndex((s) => s.id == result.leadId);
                    const existingLead = list.items[leadIndex];
                    list.items[leadIndex] = { ...existingLead, ...updatedLeadResposne.data };
                    s.list = list;
                });

                LeadOverrideStore.update((s) => {
                    s.changeDateMode = false;
                }); //Change this

                LeadScreenStore.update((s) => {
                    s.refreshLeads = true;
                });
            })
            .catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        const errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\';
                        });
                    }
                }
            });
    };

    if (item) {
        return (
            <Box sx={{ width: '600px' }}>
                <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <Typography variant="h6">
                            {item.firstName} {item.lastName}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <LeadDataFormater
                            labelText=""
                            valueText={item.jobTitle}
                            textColor="CornflowerBlue"
                            errorText="-Job Title is missing-"
                            chipHeight={20}
                            chipFontSize="0.875rem"
                            chipfontWeight={500}
                            isChip={false}
                        />
                        <LeadCompanyComponent
                            lead={item}
                            labelText="at"
                            valueText={item.company != null ? item.company : ''}
                            textColor="CornflowerBlue"
                            errorText="-Company is missing-"
                            chipHeight={20}
                            chipFontSize="0.75rem"
                            chipfontWeight={500}
                            isChip={false}
                            leadId="1"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <Divider />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <DateTimeDisplayWithLabel
                            value={formatDateLocal(item.nextActivityDateTime)}
                            label="Current Activity Date:"
                            format="date"
                            sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <CustomDatePickerNoError
                            label="Activity Date"
                            value={selectedValue}
                            onChange={handleDateChange}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                    >
                        <Tooltip title="Save">
                            <Button
                                variant="contained"
                                disabled={saveDisabled}
                                color="info"
                                onClick={onSubmit}
                                startIcon={<SaveTwoToneIcon />}
                                sx={{ mr: 3 }}
                            >
                                Save & Close
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <Box></Box>;
    }
};

export { ChangeActivityDate };

export default ChangeActivityDate;
